var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-layout', {
    attrs: {
      "width": "100%",
      "max-width": "1024"
    }
  }, [_c('console-title', [_vm.$route.params._setting ? _c('span', [_vm._v("경품 상세")]) : _c('span', [_vm._v("경품 생성")])]), _c('console-body', [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-2"
  }, [_vm._v("기본정보")]), _c('v-card-text', [_c('v-row', [_c('v-col', [_c('v-text-field', {
    attrs: {
      "label": "경품 등 수",
      "persistent-placeholder": "",
      "hide-details": "",
      "readonly": _vm.$route.params._setting
    },
    model: {
      value: _vm.config.ranking,
      callback: function callback($$v) {
        _vm.$set(_vm.config, "ranking", $$v);
      },
      expression: "config.ranking"
    }
  })], 1), _c('v-col', [_c('v-text-field', {
    attrs: {
      "label": "경품 이름",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.config.name,
      callback: function callback($$v) {
        _vm.$set(_vm.config, "name", $$v);
      },
      expression: "config.name"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', [_c('v-text-field', {
    attrs: {
      "label": "경품 재고",
      "persistent-placeholder": "",
      "hide-details": "",
      "readonly": _vm.$route.params._setting
    },
    model: {
      value: _vm.config.stock,
      callback: function callback($$v) {
        _vm.$set(_vm.config, "stock", $$v);
      },
      expression: "config.stock"
    }
  })], 1), _c('v-col', [_vm.$route.params._setting ? _c('v-text-field', {
    attrs: {
      "label": "당첨 횟수",
      "persistent-placeholder": "",
      "hide-details": "",
      "readonly": _vm.$route.params._setting
    },
    model: {
      value: _vm.config.stockCount,
      callback: function callback($$v) {
        _vm.$set(_vm.config, "stockCount", $$v);
      },
      expression: "config.stockCount"
    }
  }) : _vm._e()], 1)], 1), _c('v-row', [_c('v-col', [_c('v-text-field', {
    attrs: {
      "label": "경품 확률",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.config.percentage,
      callback: function callback($$v) {
        _vm.$set(_vm.config, "percentage", $$v);
      },
      expression: "config.percentage"
    }
  })], 1), _c('v-col')], 1)], 1), _c('v-card-actions')], 1), _c('v-card', {
    staticClass: "mt-4"
  }, [_c('v-card-title', {
    staticClass: "subtitle-2"
  }, [_vm._v("경품 이미지")]), _c('v-card-text', [_c('product-image', {
    attrs: {
      "label": "이미지"
    },
    on: {
      "remove": _vm.removeThumb
    },
    model: {
      value: _vm.config.image,
      callback: function callback($$v) {
        _vm.$set(_vm.config, "image", $$v);
      },
      expression: "config.image"
    }
  })], 1)], 1), _c('v-card', {
    staticClass: "mt-4"
  }, [_c('v-card-title', {
    staticClass: "subtitle-2"
  }, [_vm._v("당첨 이미지")]), _c('v-card-text', [_c('product-image', {
    attrs: {
      "label": "이미지"
    },
    on: {
      "remove": _vm.removeThumb
    },
    model: {
      value: _vm.config.image2,
      callback: function callback($$v) {
        _vm.$set(_vm.config, "image2", $$v);
      },
      expression: "config.image2"
    }
  })], 1)], 1)], 1), _c('v-row', {
    staticClass: "my-6"
  }, [_c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1), _c('v-spacer')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }